var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.026,
    height: 74.832,
    viewBox: "0 0 68.026 74.832",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.206,
    y1: 1.694,
    x2: 0.206,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007dfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc0056"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11825",
    "data-name": "Grupo 11825",
    transform: "translate(-3.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3422",
    "data-name": "Caminho 3422",
    d: "M57.564,22.394H54.279c1.589-4.4,3.134-10.877,1.055-15.952A10.551,10.551,0,0,0,48.592.288,5.854,5.854,0,0,0,46.777,0C42.633,0,38.883,4.045,33.4,14.431a38.62,38.62,0,0,1-8.5,10.723,17.3,17.3,0,0,0-2.592,2.722A10.526,10.526,0,0,0,3.039,33.74V64.3a10.518,10.518,0,0,0,19.528,5.44,13.474,13.474,0,0,0,10.485,5.013H58.831c10.645,0,12.234-6.871,12.234-10.965V35.9a13.516,13.516,0,0,0-13.5-13.506ZM17.38,64.3a3.811,3.811,0,0,1-7.622,0V33.74a3.811,3.811,0,1,1,7.622,0Zm46.967-.513c0,2.487-.4,4.247-5.516,4.247H33.053a6.79,6.79,0,0,1-6.783-6.782V35.9l.009-.106-.024-.2c-.007-.107-.119-2.672,3-5.319a45.809,45.809,0,0,0,10.094-12.71C43.972,8.8,46.18,7.092,46.779,6.77a3.751,3.751,0,0,1,2.337,2.218c1.448,3.534-.371,10.328-2.915,15.213l-2.556,4.91H57.563A6.792,6.792,0,0,1,64.347,35.9Z",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/ThumbsUp.7abfa290800bf82df7bfda2ecc2afcd6.svg";
export { ForwardRef as ReactComponent };